import { set } from 'lodash';
import { cleanFields } from '../Model/ApiModelCleaner';
import { validUpdateFields } from '../Model/User';

export const administratorLifecycleCallbacks = {
  resource: 'admin/users',
};
